import { render, staticRenderFns } from "./CustomerOrderView.vue?vue&type=template&id=09d9ed1a&scoped=true"
import script from "./CustomerOrderView.vue?vue&type=script&lang=js"
export * from "./CustomerOrderView.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderView.vue?vue&type=style&index=0&id=09d9ed1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9ed1a",
  null
  
)

export default component.exports